import React, { useState } from "react";
import "./card.css";
import LoadingSkeleton from "./LoadingSkeleton"; 

function Card({
  frontImage,
  backVideoUrl,
  buttonText,
  onButtonClick,
  isDisabled,
  style,
  handleSubmit,
  isLoading,
}) {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const flipCard = () => {
    if (!isDisabled) {
      setIsFlipped(!isFlipped);
    }
  };

  const handleButtonClick = () => {
    if (!isDisabled) {
      onButtonClick();
      setIsModalOpen(true);
    }
  };

  return (
    <div
      className={`card ${isFlipped ? "flipped" : ""} ${
        isDisabled ? "disabled" : ""
      }`}
      onClick={flipCard}
      style={style}
    >
      <div className="card-inner">
        <div className="card-front">
          <img className="imgc" src={frontImage} alt="Front" />
        </div>
        <div className="card-back">
          {isFlipped && (
            <>
              {isLoading ? (
                <LoadingSkeleton />
              ) : (
                <iframe
                  width="100%"
                  height="80%"
                  src={backVideoUrl}
                  title="YouTube Shorts Video"
                  frameBorder="0"
                  allowFullScreen
                  className="video"
                />
              )}
            </>
          )}
          <div
            className={`buttoon ${isDisabled ? "disabled" : ""}`}
            onClick={(e) => {
              handleSubmit(e);
              handleButtonClick();
            }}
          >
            {buttonText}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;